import {ModalWindow} from "./modalWindow.js";

export class ModalFileUpload extends ModalWindow {

   constructor(app, files, settings, callback) {
      super();

      this.app = app;
      this.files = files;
      this.settings = settings;
      this.callback = callback;

      this.panel.classList.add('dark-transparent');

      this.elMain = HTMLElement.createFromHTML(`
         <div class="modal-file-upload">
            <div class="container">
               <div class="title">Dateiupload</div>
               <div class="files">
               </div>
               <div class="buttons">
                 <div class="btn-cancel button-circle"><i class="icon-cross"></i></div>
                 <div class="btn-ok button-circle"><i class="icon-check"></i></div>
              </div>
           </div>
       </div>
       `);

      this.panel.append(this.elMain);
      this.elMain.querySelector('.btn-ok').style.filter = 'grayscale(1) brightness(1.5)';

      this.elFiles = this.elMain.querySelector('.files');

      this.elMain.querySelector('.btn-cancel').onclick = () => {
         this.close();
      };

      this.loadFiles(files);


      setTimeout(() => this.show(), 1);

   }

   loadFiles(files) {

      let uploads = [];

      for (const file of files) {
         const elFile = HTMLElement.createFromHTML(`
            <div class="file">
               <div class="bar">${file.name}
                  <div class="progress"></div>
                  <div class="message"></div>
               </div>
               <i class="icon-cogwheel rotating"></i>
            </div>
         `);
         this.elFiles.append(elFile)

         if (file.size > this.settings.maxFileSize) {
            const msg = `Dateien dürfen nicht größer als <b>${(this.settings.maxFileSize/(1024*1024)).toFixed(2)} MB</b> sein.`;
            elFile.querySelector('.message').innerText = msg;
         }
         else {
            let data = new FormData();
            data.append('file', file);
            //data.append('localIndex', i);
            uploads.push(this.app.dm.sinFileUpload(data,
               (progress) => { elFile.querySelector('.progress').style.width = (progress*100) + '%'; },
               () => {
                  const elIcon = elFile.querySelector('i');
                  elIcon.removeAttribute('class');
                  elIcon.classList.add('icon-check');
               }
            ));
         }
      }

      Promise.all(uploads)
      .then(responses => {
         let files = [];
         for (let file of responses.map(i => i.data)) {
            files.push(file)
         }

         this.elMain.querySelector('.btn-ok').style.filter = '';
         this.elMain.querySelector('.btn-ok').onclick = () => {
            this.callback(files);
            this.close();
         };

      })
      .catch(e => {
         toast.alert(e, { duration: 8000 });
         logger.error(e);
      });







   }


}
